import { Container, CountComponent, StyledIconButton } from './FilterIconButton.styles';

interface FilterIconButtonProps {
  onClick: () => void;
  icon: React.ReactNode;
  count?: number;
}

const FilterIconButton = ({ onClick, icon, count }: FilterIconButtonProps) => {
  return (
    <Container>
      <StyledIconButton icon={icon} onPress={onClick} />
      {count ? <CountComponent>{count}</CountComponent> : null}
    </Container>
  );
};

export default FilterIconButton;
